import React from "react";

import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

const FeedbackReviewedNotification: React.FC = () => (
  <NotificationBody badge="letter">
    <Trans>Your feedback has been reviewed by an administrator</Trans>
  </NotificationBody>
);

export default FeedbackReviewedNotification;
